import * as React from "react";
import "./index.css";
import { App } from "./app";
import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import { captureCampaignId } from "@/lib/mixpanel";

// Isolated on purpose: nothing else in this file is wrapped, so an uncaught
// throw here would abort the entire script before Sentry.init or React even
// mount — a blank white page for every visitor, with no error boundary able
// to catch it.
try {
  captureCampaignId();
} catch (error) {
  console.warn("[Mixpanel] Failed to capture campaign-id", error);
}

Sentry.init({
  dsn: import.meta.env.VITE_APP_SENTRY_DSN,
  environment: import.meta.env.VITE_APP_SENTRY_ENV,
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true, // TODO: Remove this once we have a proper PII policy
});

const root = document.getElementById("root");
if (!root) throw new Error("No root element found");

createRoot(root).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
